import { useEffect, useState } from "react";
import { Moon, Sun } from "lucide-react";
import { useTheme } from "next-themes";
import { Button } from "@/components/ui/button";

// Sun/Moon toggle. next-themes hydration is client-only, so we render a
// placeholder until mounted to avoid the SSR/CSR mismatch warning.
export default function ThemeToggle() {
  const { resolvedTheme, setTheme } = useTheme();
  const [mounted, setMounted] = useState(false);
  useEffect(() => setMounted(true), []);

  const isDark = mounted && resolvedTheme === "dark";
  const next = isDark ? "light" : "dark";

  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={() => setTheme(next)}
      aria-label={`Switch to ${next} mode`}
      data-testid="theme-toggle"
      className="h-9 w-9 px-0 text-[#3F3F3F] hover:bg-[#D2E4D6]/60 dark:text-foreground dark:hover:bg-accent"
    >
      {mounted ? (
        isDark ? <Sun className="w-4 h-4" /> : <Moon className="w-4 h-4" />
      ) : (
        // Placeholder while next-themes resolves the persisted value.
        <Moon className="w-4 h-4 opacity-0" />
      )}
    </Button>
  );
}
